import api from './api';
import { EquipmentType } from '../types/equipment-type';

export function getEquipmentTypes() {
    return api.get<{ data: EquipmentType[] }>('/equipment/types');
}

export function getEquipmentType(id: number) {
    return api.get<{ data: EquipmentType }>(`/equipment/types/${id}`);
}

export function createEquipmentType(data: Omit<EquipmentType, 'id' | 'created_at' | 'updated_at'>) {
    return api.post<{ data: EquipmentType }>('/equipment/types', data);
}

export function updateEquipmentType(id: number, data: Partial<EquipmentType>) {
    return api.put<{ data: EquipmentType }>(`/equipment/types/${id}`, data);
}

export function deleteEquipmentType(id: number) {
    return api.delete<{ success: boolean }>(`/equipment/types/${id}`);
}

export default {
    getEquipmentTypes,
    getEquipmentType,
    createEquipmentType,
    updateEquipmentType,
    deleteEquipmentType
}; 